import { format } from 'date-fns'
import { FacilityOpeningTime } from '../entites/FacilityOpeningTime'

export const getOpeningTimeText = (
  openingTime: FacilityOpeningTime,
  formatable?: boolean,
): string => {
  let startText = openingTime.start_time
  let endText = openingTime.end_time

  if (formatable) {
    startText = format(new Date(openingTime.start_time), 'H:mm')
    endText = format(new Date(openingTime.end_time), 'H:mm')
  }

  return `${openingTime.opening_day} ${startText}～${endText}`
}
